/**
 * Local camera configuration for this booth device.
 * QR scan and photo capture can use different cameras (e.g. built-in for QR, DSLR for photos).
 */

const STORAGE_KEY = 'photobooth_camera_config';

export interface CameraConfig {
  /** Device ID for QR code scanning (e.g. built-in webcam). Empty = browser default. */
  qrCameraDeviceId: string | null;
  /** Device ID for photo capture (e.g. DSLR). Empty = browser default. */
  photoCameraDeviceId: string | null;
}

const defaults: CameraConfig = {
  qrCameraDeviceId: null,
  photoCameraDeviceId: null,
};

function parseStored(raw: string | null): CameraConfig {
  if (!raw) return { ...defaults };
  try {
    const o = JSON.parse(raw) as Partial<CameraConfig>;
    return {
      qrCameraDeviceId: typeof o.qrCameraDeviceId === 'string' ? o.qrCameraDeviceId : null,
      photoCameraDeviceId: typeof o.photoCameraDeviceId === 'string' ? o.photoCameraDeviceId : null,
    };
  } catch {
    return { ...defaults };
  }
}

export function getCameraConfig(): CameraConfig {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return parseStored(stored);
  } catch {
    return { ...defaults };
  }
}

export function setCameraConfig(config: Partial<CameraConfig>): void {
  const current = getCameraConfig();
  const next: CameraConfig = {
    qrCameraDeviceId: config.qrCameraDeviceId !== undefined ? config.qrCameraDeviceId : current.qrCameraDeviceId,
    photoCameraDeviceId: config.photoCameraDeviceId !== undefined ? config.photoCameraDeviceId : current.photoCameraDeviceId,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
